"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridInfoModule = void 0;
const tslib_1 = require("tslib");
const AdaptableModuleBase_1 = require("./AdaptableModuleBase");
const ModuleConstants = tslib_1.__importStar(require("../Utilities/Constants/ModuleConstants"));
class GridInfoModule extends AdaptableModuleBase_1.AdaptableModuleBase {
    constructor(api) {
        super(ModuleConstants.GridInfoModuleId, ModuleConstants.GridInfoFriendlyName, 'align-justify', 'GridInfoPopup', 'Display information about the Grid, the Options selected and all columns', api);
    }
    getViewAccessLevel() {
        return 'Full';
    }
    addColumnMenuItems(column) {
        if (this.isModuleAvailable()) {
            return [
                this.createMainMenuItemShowPopup({
                    Label: 'Grid Info',
                    ComponentName: this.moduleInfo.Popup,
                    Icon: this.moduleInfo.Glyph,
                }),
            ];
        }
    }
    addContextMenuItems(menuContext) {
        if (this.isModuleAvailable()) {
            return [
                this.createMainMenuItemShowPopup({
                    Label: 'Grid Info',
                    ComponentName: this.moduleInfo.Popup,
                    Icon: this.moduleInfo.Glyph,
                }),
            ];
        }
    }
}
exports.GridInfoModule = GridInfoModule;
